angular.module('olivioConfiguratorApp')
	.factory('Model', function ($q, $rootScope, $resource, Data, env) {
		var defaults = {
			locale: 'en',
			dataVariant: env.dataVariant, // FIXME klären ob es dataVariant noch gibt und ggf. entfernen
			userOptions:{
				advanced: false,
				showArticleNumbers: false, //show: enable Option to show ... in specsheet
				showPrices: false,
				showDrillHoles: false,
				displayArticleNumbers: false, //show: display ... in specsheet
				displayPrices: false,
				displayDrillHoles: false
			},
			person: {
				entered: false,
				company: '',
				contact: '',
				phone: '',
				email: '',
				street: '',
				number: '',
				zip: '',
				city: '',
				country: '',
				projectName: '',
				projectId: '',
				projectAddress: '',
				projectNotes: ''
			},
			subtotal: 6110, // TODO this should not be stored but calculated based on data in data.js
			product: {
				id: '',
				done: false
			},
			design: {
				colorIds: {
					mast: 'seluxGraphite',
					lumiere: 'seluxGraphite',
					inlay: 'ral9010'
				},
				lumtype: OLIVIO.LUM_GRANDE,
				beamtype: OLIVIO.BRACKET_SISTEMA1,
				height: 12000,
				diameter: '',
				topToBottomRotation: 315,
				startDegree: 0,
				topToBottomRotationCW: true,
				toplumiereheight: 11200,
				bottomlumiereheight: 7000,
				individualHeights: [11200, 10600, 10000, 9400, 8800, 8200, 7600, 7000],
				individualRotations: [0, 45, 90, 135, 180, 225, 270, 315],
				individualHeads: [OLIVIO.LUM_GRANDE, OLIVIO.LUM_GRANDE, OLIVIO.LUM_GRANDE, OLIVIO.LUM_GRANDE, OLIVIO.LUM_GRANDE, OLIVIO.LUM_GRANDE, OLIVIO.LUM_GRANDE, OLIVIO.LUM_GRANDE], // not to be changed as this would introduce a dependency beetween resetGobo and resetDesign
				lumcount: 8,
        anchor: false,
				advanced: false,
				done: false,
        gobo: false // this is only a switch if in design is in gobo editing
			},
      charging: {
        count: 0,
        power: '0',
        type: '1',
        arrangement: 0,
        done: false
      },
			assembly: {
				id: 'led',
				individual: [],
				done: true
			},
			distribution: {
				id: '',
				individual: [],
        done: false
			},
      gobo: {
        id: '',
        individualType: [],
        individual: [],
        done: false
      },
			color: {
				id: '',
				individual: [],
				done: false
			},
			power: {
				id: '',
				individual: [],
				done: false
			},
			details: {
				id: '',
				done: false
			},
			checkout: {
				id: '',
				done: false
			}
		};

		var configurationSchema = {
			type: 'object',
			properties: {
				assembly: {
					type: 'object',
					properties: {
						done: {type: 'boolean'},
						id: {type: 'string'},
						individual: {type: 'array'}
					}
				},
				color: {
					type: 'object',
					properties: {
						done: {type: 'boolean'},
						id: {type: 'string'},
						individual: {type: 'array'}
					}
				},
				design: {
					type: 'object',
					properties: {
						advanced: {type: 'boolean'},
						beamtype: {type: 'string'},
						bottomlumiereheight: {type: 'number'},
						colorIds: {
							type: 'object',
							properties: {
								inlay: {type: 'string'},
								lumiere: {type: 'string'},
								mast: {type: 'string'}
							}
						},
						done: {type: 'boolean'},
						height: {type: 'number'},
						individualHeights: {
							type: 'array',
							items: {type: 'number'}
						},
						individualRotations: {
							type: 'array',
							items: {type: 'number'}
						},
						individualHeads: {
							type: 'array',
							items: {type: 'string'}
						},
						lumcount: {type: 'number'},
						lumtype: {type: 'string'},
						startDegree: {type: 'number'},
						topToBottomRotationCW: {type: 'boolean'},
						topToBottomRotation: {type: 'number'},
						toplumiereheight: {type: 'number'},
            anchor: {ŧype: 'boolean'},
            gobo: {type: 'boolean'}
          }
				},
        charging: {
          type: 'object',
          properties: {
            count: {type: 'number'},
            power: {type: 'string'},
            type: {type: 'string'},
            arrangement: {type: 'number'},
            done: {type: 'boolean'}
          }
        },
        details: {
					type: 'object',
					properties: {
						done: {type: 'boolean'},
						id: {type: 'string'}
					}
				},
				distribution: {
					type: 'object',
					properties: {
						done: {type: 'boolean'},
						id: {type: 'string'},
						individual: {type: 'array'}
					}
				},
        gobo: {
          type: 'object',
          properties: {
            done: {type: 'boolean'},
            id: {type: 'string'},
            individual: {type: 'array'},
            individualType: {type: 'array'}
          }
        },
				power: {
					type: 'object',
					properties: {
						done: {type: 'boolean'},
						id: {type: 'string'},
						individual: {type: 'array'}
					}
				},
				product: {
					type: 'object',
					properties: {
						done: {type: 'boolean'},
						id: {type: 'string'}
					}
				}
			}
		};

		function filterObjectByJsonSchema(object, schema) {
			switch (schema && schema.type) {
				case 'object':
					var result = {};
					_.forEach(schema.properties, function (propertySchema, propertyKey) {
						if (object.hasOwnProperty(propertyKey)) {
							result[propertyKey] = filterObjectByJsonSchema(object[propertyKey], propertySchema);
						}
					});
					return result;

				case 'array':
					return _.map(object, function (item) {
						return filterObjectByJsonSchema(item, schema.items);
					});
			}

			return object;
		}


		var service = {
			model: angular.copy(defaults),

			ensureValidState: function () {
				var m = service.model;

        // fix old invalid data with known values
        if(m.product.id === (m.product.id === OLIVIO.PRODUCT_FLORACION)) {
          m.design.lumtype = OLIVIO.LUM_GRANDE;
        }
        if(!m.assembly.id || m.assembly.id === 'led') {
          m.assembly.id = 'led';
          m.assembly.done = true;
        }

        // TODO checkLumOption fehlt

				if (!Data.checkProductOption(m.product.id)) {
          console.log('checkProductOption failed!');
					service.resetProduct();
				} else if (!Data.checkDesignOptions(m.product.id, m.design.height, m.design.lumcount, m.design.lumtype, m.design.beamtype)) {
          console.log('checkDesignOptions failed!');
					service.resetDesign();
				} else if (!Data.checkAssemblyOptions(m.product.id, m.design.lumtype, m.assembly.id)) {
          console.log('checkAssemblyOptions failed!');
					service.resetAssembly();
        } else if (!Data.checkColorOption(m.product.id, m.design.lumtype, m.assembly.id, m.distribution.id, m.color.id)) {
          console.log('checkColorOption failed!');
          service.resetColor();
        } else if (!Data.checkDistributionOptions(m.product.id, m.design.lumtype, m.assembly.id, m.distribution.id, m.color.id)) {
          console.log('checkDistributionOptions failed!');
          service.resetDistribution();
        } else if (!Data.checkPowerOption(m.product.id, m.design.lumtype, m.assembly.id, m.distribution.id, m.color.id, m.power.id)) {
          console.log('checkPowerOption failed!');
					service.resetPower();
				} else {
          console.log('all simple data checks passed.');
        }

        if(!Data.checkChargingOptions(m.charging.count, m.charging.type, m.charging.power)) {
          console.log('charging check failed, resetting charging data only');
          service.resetCharging();
        }
        // ensure some states
        m.charging.info = false; // close info on reload
        m.design.goboInfo = false; // close info on reload
        m.design.anchor = !!m.design.anchor; // upgrade old models

        // Gobo is some kind of orthogonal to all the other options
        if(!Data.checkGobo(m.gobo, m.design)) {
          console.log('gobo check failed, resetting gobo data only');
          service.resetGobo();
        }

			},

			reset: function () {
        // preserve advanced login and user options
				var userOptions = service.model.userOptions;
				service.model = angular.copy(defaults);
				service.model.userOptions = userOptions;

        console.log('reset all', service.model);

				//service.resetProduct();  // not needed at all! angular.copy does all this.
				//service.resetDesign();  called by resetProduct()
        //service.resetGobo();   // called by resetDesign()
			  //service.resetAssembly(); // calls resetDistribution
        //service.resetIndividualHeads();  // called by resetDesign
				//service.resetDistribution(); // called by resetAssembly()
				//service.resetColor();  // called by resetDistribution()
				//service.resetPower(); // called by resetColor();
			},

			extractConfiguration: function () {
				return filterObjectByJsonSchema(service.model, configurationSchema);
			},

			getDone: function (view) {
				return service.model[view].done;
			},

			resetUserOptions: function () {
				service.model.userOptions = angular.copy(defaults.userOptions);
			},


			/** resets Model data to defaults starting with product.<br>
			 *  callers have to ensure a following call to one of StepService.gotoStep(), StepService.previousStep(), StepService.nextStep() or StepService.updateEnabled()
			 */
			resetProduct: function () {
				service.model.product = angular.copy(defaults.product);
        service.resetDesign();
			},

			/** resets Model data to defaults starting with design.<br>
			 *  callers have to ensure a following call to one of StepService.gotoStep(), StepService.previousStep(), StepService.nextStep() or StepService.updateEnabled()
			 */
			resetDesign: function () {
			  console.log('resetDesign');
        service.model.design = angular.copy(defaults.design);

        var floracion = (service.model.product.id === OLIVIO.PRODUCT_FLORACION)
        Data.getLumOption(OLIVIO.LUM_MEDIO).disabled = floracion;
        Data.getLumOption(OLIVIO.LUM_PICCOLO).disabled = floracion;

        service.resetIndividualHeads();
        service.resetCharging();
        service.resetGobo();
        service.resetAssembly();
			},

			/** resets Model data to defaults starting with assembly.<br>
			 *  callers have to ensure a following call to one of StepService.gotoStep(), StepService.previousStep(), StepService.nextStep() or StepService.updateEnabled()
			 */
			resetAssembly: function () {
				console.log('resetAssembly');
				service.model.assembly = angular.copy(defaults.assembly);
				service.resetColor();
			},


      /** resets Model data to defaults starting with color.<br>
       *  callers have to ensure a following call to one of StepService.gotoStep(), StepService.previousStep(), StepService.nextStep() or StepService.updateEnabled()
       */
      resetColor: function () {
        console.log('resetColor');
        service.model.color = angular.copy(defaults.color);
        service.resetDistribution();
      },

      /** resets Model data to defaults starting with distribution.<br>
			 *  callers have to ensure a following call to one of StepService.gotoStep(), StepService.previousStep(), StepService.nextStep() or StepService.updateEnabled()
			 */
			resetDistribution: function () {
				console.log('resetDistribution');
				service.model.distribution = angular.copy(defaults.distribution);
        // do NOT reset service.model.gobo. Yes, it's displayed on the distribution screen, but it's reset is handled by the only dependency: the toggleGobo() in design.js
				service.resetPower();
			},


			/** resets Model data to defaults starting with power.<br>
			 *  callers have to ensure a following call to one of StepService.gotoStep(), StepService.previousStep(), StepService.nextStep() or StepService.updateEnabled()
			 */
			resetPower: function () {
				console.log('resetPower');
				service.model.power = angular.copy(defaults.power);
      },


      /** resets individual assembly data to defaults<br>
       *  for special cases in advanced editing to prevent individual incompatible head-assembly combinations
       */
      resetIndividualHeads: function () {
        console.log('resetIndividualHeads');
        service.model.design.individualHeads = angular.copy(defaults.design.individualHeads);
        for(var i=0; i<=service.model.gobo.individual; i++) {
          if(service.model.gobo.individual[i]) {
            service.model.design.individualHeads[i] = OLIVIO.LUM_GRANDE;
          }
        }
      },

      resetGobo: function() {
        console.log('resetGobo');
        service.model.design.gobo = false;
        service.model.gobo = angular.copy(defaults.gobo);
      },

      resetCharging: function () {
        console.log('resetCharging');
        service.model.charging = angular.copy(defaults.charging);
      },

      goboAllowed: function() {
        return (service.model.product.id !== OLIVIO.PRODUCT_CANDELABRA || service.model.design.lumtype === OLIVIO.LUM_GRANDE); // !== 'candelabra' is sistema (mix allowed) or floracion (always grande) and with candelabra all heads are this.design.lumtype
      },

      haveGobo: function() {
        if(service.goboAllowed()) {
          for (var i = 0; i < service.model.gobo.individual.length; i++) {
            if (service.model.gobo.individual[i]) {
              return true;
            }
          }
        }
        return false;
      },

      /**
       * @returns object array with key=view's name, boolean value=view' skipped flag. Won't mention view's which skip state never changes.
       */
      getSkippedViews: function () {
        return {
          color: (service.model.assembly.done && service.model.assembly.id !== 'led'),
          gobo: !service.haveGobo()
        };
      }

    };

		return service;
	});
